import pathRoute from "../const/routePaths";
function guardCheck(_: any, pageName: string) {
  const companyType = localStorage.getItem("companyType");

  if (!!companyType && !pathRoute[companyType as string].includes(pageName)) {
    return false;
  }
  return true;
}
export default guardCheck;
